import React from "react";
import { Radio } from "antd";
import { getIconUrl } from "../../../../services/asset";
import styles from "./styles/SortOptionItem.scss";

function SortOptionItem({ option, onSortItemClick }) {
  return (
    <div
      role="button"
      tabIndex={0}
      key={option.value}
      className={styles.sortOption}
      onClick={() => onSortItemClick(option.value)}
    >
      <div className={styles.imgTextContainer}>
        <img
          alt={option.name}
          src={getIconUrl(option.iconId)}
          className={styles.sortIcon}
        />
        <span className={styles.text}>{option.name}</span>
      </div>
      <Radio value={option.value}></Radio>
    </div>
  );
}

export default SortOptionItem;



// WEBPACK FOOTER //
// ./src/components/SortOption/SortOptionMobile/SortOptionItem/index.tsx